// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-ek2","content":"styles_content__WP_vj","row":"styles_row__3SwTV","footer":"styles_footer__33Qp-","phraseLength":"styles_phraseLength__1Ak7Z"};